import { useEffect, useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { FileItemType } from "../../types/communication/communicationDataType";
import CameraUploadListCmp from "../custom-camera/CameraUploadListCmp";
import { CameraMiniatureBadgeItem, FilePreviewImg, SectionCameraFotoContainer } from "../styled/File.style";
import CameraFotoMiniatureItem from "../custom-camera/CameraFotoMiniatureItem";
import { PhotoTypeEnum } from "../../types/commonTypes";

export interface FotoMultiSectionProps {
    fileType: PhotoTypeEnum
    additionalBeInfo?: any
    files: FileItemType[]
    setFiles: any,
    arrayDbPropSync?: string
    textLabel?: string
    titleImageDetail?: string
    minPhotoNumber: number
}

const FotoMultiSection = (props: FotoMultiSectionProps) => {
    const { files, setFiles, arrayDbPropSync, textLabel, titleImageDetail, minPhotoNumber, fileType, additionalBeInfo } = props
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData

    const [lastPhoto, setLastPhoto] = useState<string | null>(null);
    const [showCamera, setShowCamera] = useState(false)
    const [previewPhotoInitCmp, setPreviewPhotoInitCmp] = useState<any>(null)

    const procedureDoneClickHandler = () => {
        setShowCamera(false)
    }

    const numPhotos = files?.length
    const photoImgCmp = lastPhoto ? <img src={lastPhoto} alt="Captured" style={{ maxWidth: '100%', maxHeight: '100%' }} /> : previewPhotoInitCmp
    const badgeCmp = numPhotos ? <CameraMiniatureBadgeItem>{numPhotos}</CameraMiniatureBadgeItem> : null
    const photoPreviewCmp = <CameraFotoMiniatureItem
        photo={photoImgCmp}
        badge={badgeCmp} />

    const procedureDoneBtn = <button
        disabled={!numPhotos || numPhotos < minPhotoNumber}
        className="procedure-done-btn"
        onClick={procedureDoneClickHandler}>Fatto</button>

    const onCloseHandler = () => {
        setShowCamera(false)
    }

    const photoClickHandler = (_ph: any) => {
        setLastPhoto(_ph)
    }

    useEffect(() => {
        // On component loading, if a photo (file) exists, then load it
        if (!files?.length) {
            return;
        }
        const lastFile: FileItemType = files[files.length - 1]
        let previewURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${communication?.token}/download-attachment/${lastFile?._id}`;
        const initPreviewCameraImage = <FilePreviewImg src={previewURL} alt="Foto contesto preview" />
        setPreviewPhotoInitCmp(initPreviewCameraImage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <SectionCameraFotoContainer>
            {<CameraUploadListCmp
                fileType={fileType}
                additionalBeInfo={additionalBeInfo}
                photoClickHandler={photoClickHandler}
                onCloseHandler={onCloseHandler}
                rightItem={procedureDoneBtn}
                leftItem={photoPreviewCmp}
                showCamera={showCamera}
                setShowCamera={setShowCamera}

                files={files}
                setFiles={setFiles}
                arrayDbPropSync={arrayDbPropSync}
                textLabel={textLabel}
                titleImageDetail={titleImageDetail}
            />}
        </SectionCameraFotoContainer>
    )
}

export default FotoMultiSection